import "./ChefsSection.scss";
import ChefCard from "../ChefCard/ChefCard";

function ChefsSection() {
  const chefs = [
    {
      name: "Juan Carlos",
      img: "https://www.parkregisgoa.in/wp-content/uploads/2020/04/chef-video-placeholder@2x-624x600.jpg",
      recipesCount: "10",
      cuisine: "Mexican",
    },
    {
      name: "John Doe",
      img: "https://c0.wallpaperflare.com/preview/539/724/1000/beard-chef-cook-cuisine.jpg",
      recipesCount: "12",
      cuisine: "Japanese",
    },
    {
      name: "Erich Maria",
      img: "https://news.uga.edu/wp-content/uploads/2022/11/ChefJorgeNoriega-07-Square.jpg",
      recipesCount: "15",
      cuisine: "Italian",
    },
    {
      name: "Chris Brown",
      img: "https://nationaltoday.com/wp-content/uploads/2021/07/shutterstock_1518533924-min.jpg",
      recipesCount: "18",
      cuisine: "American",
    },
    {
      name: "Blake Lively",
      img: "https://www.onlinedegree.com/wp-content/uploads/2016/11/master_chef.jpg",
      recipesCount: "20",
      cuisine: "French",
    },
    {
      name: "Ben Affleck",
      img: "https://www.ecpi.edu/sites/default/files/Aug%2022%20CIV.png",
      recipesCount: "17",
      cuisine: "Indian",
    },
  ];

  return (
    <div className="section chefs">
      <h1 className="title">Our Top Chefs</h1>
      <div className="top-chefs-container">
        {chefs.map((items) => (
          <ChefCard key={items.name} chef={items} />
        ))}
      </div>
    </div>
  );
}

export default ChefsSection;
